// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * RT2 revamp — Jira requirements list + AI scenario/test-case views.
 * One surface language: flat cards, clean table, no boxed typography.
 */

/* ═══════════════════════════════════════════
   Jira host / toolbar
   ═══════════════════════════════════════════ */

.rt-jira-host.jira-items-overlay,
.rt-define-panel .rt-jira-host {
  background: transparent !important;
}

.rt-jira-host .jira-items-container {
  background: transparent !important;
  gap: 0;
}

.rt-jira-host .jira-items-tabs,
.rt-define-jira-toolbar {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 14px !important;
  padding: 0 0 12px !important;
  background: transparent !important;
  border: none !important;
  border-bottom: 1px solid var(--border) !important;
  box-shadow: none !important;
}

.rt-define-jira-tabs .tab-btn {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: var(--text-secondary) !important;
}

.rt-define-jira-tabs .tab-btn.active {
  color: var(--primary) !important;
  background: color-mix(in srgb, var(--primary) 10%, transparent) !important;
  box-shadow: none !important;
}

.rt-define-jira-actions .generate-all-scenarios-btn,
.rt-define-jira-actions .generate-all-tests-btn {
  height: 34px;
  padding: 0 12px !important;
  border-radius: 8px !important;
  font-size: 0.8125rem !important;
  font-weight: 600 !important;
  box-shadow: none !important;
}

.rt-define-jira-actions .generate-all-scenarios-btn {
  background: color-mix(in srgb, #f59e0b 14%, var(--surface)) !important;
  border: 1px solid color-mix(in srgb, #f59e0b 35%, var(--border)) !important;
  color: #b45309 !important;
}

[data-theme='dark'] .rt-define-jira-actions .generate-all-scenarios-btn {
  color: #fbbf24 !important;
}

.rt-define-jira-actions .generate-all-tests-btn {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  color: var(--primary) !important;
}

.rt-jira-host .sync-stories-btn,
.rt-jira-host .sync-epic-btn,
.rt-define-panel .sync-stories-btn,
.rt-define-panel .sync-epic-btn {
  height: 34px;
  padding: 0 12px !important;
  border-radius: 8px !important;
  background: var(--primary) !important;
  border: 1px solid transparent !important;
  color: #fff !important;
  font-weight: 600 !important;
  box-shadow: none !important;
}

.rt-jira-host .pagination-info,
.rt-define-panel .pagination-info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: var(--text-secondary) !important;
  font-size: 0.8125rem;
}

/* Keep Sync Epics right-aligned with the per-epic action buttons:
   card border (1) + header padding (16) + meta gap (16) + icon margin (8) + icon width (16). */
.rt-jira-host .epic-header .expand-icon {
  display: inline-flex;
  justify-content: center;
  width: 16px;
}

@media (min-width: 769px) {
  .rt-jira-host .epics-list > .pagination-info .sync-epic-btn {
    margin-right: 57px;
  }
}

/* ═══════════════════════════════════════════
   Stories table — single surface, flat cells
   ═══════════════════════════════════════════ */

.rt-jira-host .stories-table,
.rt-define-panel .stories-table,
.rt-legacy-embed .stories-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: none !important;
  color: var(--text-primary) !important;
}

.rt-jira-host .stories-table thead,
.rt-define-panel .stories-table thead {
  background: transparent !important;
}

.rt-jira-host .stories-table th,
.rt-define-panel .stories-table th {
  padding: 10px 14px !important;
  text-align: left !important;
  font-size: 11px !important;
  font-weight: 650 !important;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted) !important;
  background: color-mix(in srgb, var(--text-primary) 3%, transparent) !important;
  border-bottom: 1px solid var(--border) !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
}

.rt-jira-host .stories-table td,
.rt-define-panel .stories-table td {
  padding: 12px 14px !important;
  vertical-align: middle !important;
  text-align: left !important;
  background: transparent !important;
  border-bottom: 1px solid var(--border-subtle, var(--border)) !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  box-shadow: none !important;
  color: var(--text-primary) !important;
}

.rt-jira-host .stories-table tbody tr:last-child td,
.rt-define-panel .stories-table tbody tr:last-child td {
  border-bottom: none !important;
}

.rt-jira-host .stories-table tbody tr:hover td,
.rt-define-panel .stories-table tbody tr:hover td {
  background: color-mix(in srgb, var(--primary) 5%, transparent) !important;
}

/* Kill accidental boxes on cell text */
.rt-jira-host .stories-table td *,
.rt-define-panel .stories-table td *:not(.status-badge):not(.priority-badge):not(button):not(svg):not(path):not(circle) {
  background: transparent !important;
  box-shadow: none !important;
  text-shadow: none !important;
}

.rt-jira-host .story-summary-cell,
.rt-define-panel .story-summary-cell {
  display: flex;
  flex-direction: column;
  gap: 3px;
  max-width: 340px;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.rt-jira-host .story-summary-cell > div:first-child,
.rt-define-panel .story-summary-cell > div:first-child {
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--text-primary) !important;
  background: transparent !important;
  border: none !important;
  line-height: 1.35;
}

.rt-jira-host .story-description,
.rt-define-panel .story-description {
  font-size: 12px !important;
  color: var(--text-muted) !important;
  background: transparent !important;
  border: none !important;
  max-width: 340px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-jira-host .stories-table td:first-child,
.rt-define-panel .stories-table td:first-child {
  font-weight: 650;
  color: var(--primary) !important;
  font-size: 0.8125rem;
  white-space: nowrap;
}

.rt-jira-host .epic-link,
.rt-define-panel .epic-link {
  color: var(--primary) !important;
  background: transparent !important;
  border: none !important;
  font-weight: 550;
  font-size: 0.8125rem;
}

/* Badges — intentional tinted chips only */
.rt-jira-host .status-badge,
.rt-define-panel .status-badge,
.rt-jira-host .priority-badge,
.rt-define-panel .priority-badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px !important;
  border-radius: 999px !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  border: 1px solid transparent !important;
  box-shadow: none !important;
  white-space: nowrap;
}

.rt-jira-host .status-todo,
.rt-define-panel .status-todo {
  background: var(--bg-tertiary) !important;
  color: var(--text-secondary) !important;
}

.rt-jira-host .status-in-progress,
.rt-define-panel .status-in-progress {
  background: var(--info-muted, rgba(59, 130, 246, 0.12)) !important;
  color: var(--info, #3b82f6) !important;
}

.rt-jira-host .status-done,
.rt-define-panel .status-done {
  background: var(--success-muted) !important;
  color: var(--success) !important;
}

.rt-jira-host .priority-high,
.rt-define-panel .priority-high,
.rt-jira-host .priority-badge.priority-high,
.rt-define-panel .priority-badge.priority-high {
  background: var(--danger-muted) !important;
  color: var(--danger) !important;
}

.rt-jira-host .priority-medium,
.rt-define-panel .priority-medium {
  background: var(--warning-muted) !important;
  color: #b45309 !important;
}

[data-theme='dark'] .rt-jira-host .priority-medium,
[data-theme='dark'] .rt-define-panel .priority-medium {
  color: #fbbf24 !important;
}

.rt-jira-host .priority-low,
.rt-define-panel .priority-low {
  background: var(--success-muted) !important;
  color: var(--success) !important;
}

/* Row actions */
.rt-jira-host .story-action-buttons,
.rt-define-panel .story-action-buttons,
.rt-jira-host .epic-action-buttons,
.rt-define-panel .epic-action-buttons {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.rt-jira-host .generate-tests-btn,
.rt-define-panel .generate-tests-btn,
.rt-jira-host .generate-scenarios-btn,
.rt-define-panel .generate-scenarios-btn,
.rt-jira-host .view-tests-btn,
.rt-define-panel .view-tests-btn,
.rt-jira-host .view-scenarios-btn,
.rt-define-panel .view-scenarios-btn {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  height: 30px;
  padding: 0 10px !important;
  border-radius: 7px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 1px solid var(--border) !important;
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  box-shadow: none !important;
  cursor: pointer;
  white-space: nowrap;
}

.rt-jira-host .generate-tests-btn,
.rt-define-panel .generate-tests-btn {
  color: var(--primary) !important;
  border-color: color-mix(in srgb, var(--primary) 30%, var(--border)) !important;
  background: color-mix(in srgb, var(--primary) 8%, var(--surface)) !important;
}

.rt-jira-host .generate-scenarios-btn,
.rt-define-panel .generate-scenarios-btn {
  color: #b45309 !important;
  border-color: color-mix(in srgb, #f59e0b 35%, var(--border)) !important;
  background: color-mix(in srgb, #f59e0b 10%, var(--surface)) !important;
}

[data-theme='dark'] .rt-jira-host .generate-scenarios-btn,
[data-theme='dark'] .rt-define-panel .generate-scenarios-btn {
  color: #fbbf24 !important;
}

.rt-jira-host .view-tests-btn,
.rt-define-panel .view-tests-btn,
.rt-jira-host .view-scenarios-btn,
.rt-define-panel .view-scenarios-btn {
  color: var(--success) !important;
  border-color: color-mix(in srgb, var(--success) 30%, var(--border)) !important;
  background: color-mix(in srgb, var(--success) 10%, var(--surface)) !important;
}

/* Epic list cards */
.rt-jira-host .epic-item,
.rt-define-panel .epic-item {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: 12px !important;
  margin-bottom: 10px;
  overflow: hidden;
  box-shadow: none !important;
}

.rt-jira-host .epic-header,
.rt-define-panel .epic-header {
  background: transparent !important;
  padding: 14px 16px !important;
  border: none !important;
}

.rt-jira-host .epic-header:hover,
.rt-define-panel .epic-header:hover {
  background: color-mix(in srgb, var(--primary) 4%, transparent) !important;
}

.rt-jira-host .epic-summary,
.rt-define-panel .epic-summary,
.rt-jira-host .jira-key,
.rt-define-panel .jira-key,
.rt-jira-host .epic-description,
.rt-define-panel .epic-description,
.rt-jira-host .epic-assignee,
.rt-define-panel .epic-assignee {
  background: transparent !important;
  box-shadow: none !important;
  text-shadow: none !important;
}

.rt-jira-host .epic-details,
.rt-define-panel .epic-details {
  background: color-mix(in srgb, var(--text-primary) 2%, transparent) !important;
  border-top: 1px solid var(--border) !important;
  padding: 14px 16px !important;
}

.rt-jira-host .story-item,
.rt-define-panel .story-item {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: 8px !important;
  padding: 10px 12px !important;
  box-shadow: none !important;
}

/* ═══════════════════════════════════════════
   AI scenario / test-case generator
   ═══════════════════════════════════════════ */

.rt-scenario-page .ai-testcase-generator-container,
.rt-scenario-page.rt-scenario-page {
  background: var(--bg-primary) !important;
  color: var(--text-primary) !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  margin-top: 0 !important;
  height: auto !important;
  min-height: 0 !important;
}

.rt-scenario-page .rt-scenario-chrome {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: 12px !important;
  margin: 0 0 14px !important;
  padding: 14px 16px !important;
}

.rt-scenario-page .generator-content {
  background: transparent !important;
  padding: 0 !important;
}

.rt-scenario-page .test-cases-header,
.rt-scenario-page .rt-scenario-toolbar {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: 12px !important;
  padding: 12px 14px !important;
  margin-bottom: 14px !important;
  box-shadow: none !important;
}

.rt-scenario-page .test-cases-title h3 {
  margin: 0 !important;
  font-size: 0.95rem !important;
  font-weight: 650 !important;
  color: var(--text-primary) !important;
  background: transparent !important;
}

.rt-scenario-page .test-case-card {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: 12px !important;
  padding: 16px 18px !important;
  margin-bottom: 12px;
  box-shadow: none !important;
  color: var(--text-primary) !important;
}

.rt-scenario-page .test-case-header,
.rt-scenario-page .test-case-meta,
.rt-scenario-page .test-case-description,
.rt-scenario-page .test-case-content,
.rt-scenario-page .test-case-section {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.rt-scenario-page .test-case-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  padding-bottom: 0 !important;
}

.rt-scenario-page .test-case-title {
  margin: 0 !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
  color: var(--text-primary) !important;
  background: transparent !important;
}

.rt-scenario-page .test-case-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-bottom: 12px !important;
  font-size: 0.8125rem;
  color: var(--text-secondary) !important;
}

.rt-scenario-page .test-case-meta span,
.rt-scenario-page .test-case-meta strong {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.rt-scenario-page .test-case-description {
  margin: 0 0 14px !important;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-secondary) !important;
}

.rt-scenario-page .test-case-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 0 !important;
  margin: 0 !important;
}

.rt-scenario-page .test-case-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 !important;
  margin: 0 !important;
}

.rt-scenario-page .test-case-section > h4,
.rt-scenario-page .test-case-section h4 {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-muted) !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  text-shadow: none !important;
}

.rt-scenario-page .test-case-section p,
.rt-scenario-page .test-case-section li,
.rt-scenario-page .preconditions-list,
.rt-scenario-page .preconditions-list li {
  margin: 0 !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  text-shadow: none !important;
  color: var(--text-primary) !important;
  font-size: 0.875rem;
  line-height: 1.5;
}

.rt-scenario-page .test-case-section ol,
.rt-scenario-page .test-case-section ul {
  margin: 0 !important;
  padding-left: 1.15rem !important;
  background: transparent !important;
}

.rt-scenario-page .bdd-step {
  background: color-mix(in srgb, var(--text-primary) 4%, transparent) !important;
  border-radius: 8px !important;
  color: var(--text-primary) !important;
}

.rt-scenario-page .expected-result {
  background: color-mix(in srgb, var(--success) 8%, transparent) !important;
  border-left: 3px solid var(--success) !important;
  color: var(--text-primary) !important;
  border-radius: 0 8px 8px 0 !important;
}

.rt-scenario-page .regenerate-btn {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  color: var(--text-primary) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}

.rt-scenario-page .back-btn,
.rt-jira-host > .back-btn,
.rt-jira-host .jira-items-container > .back-btn {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  color: var(--text-primary) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-jira-revamp.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;gDAEgD;;AAEhD;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,MAAM;AACR;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,uBAAuB;EACvB,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,0EAA0E;EAC1E,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sEAAsE;EACtE,2EAA2E;EAC3E,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;;;;EAIE,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,qCAAqC;EACrC,wCAAwC;EACxC,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;+FAC+F;AAC/F;EACE,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;;gDAEgD;;AAEhD;;;EAGE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,8EAA8E;EAC9E,iDAAiD;EACjD,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,kCAAkC;EAClC,uEAAuE;EACvE,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,yEAAyE;AAC3E;;AAEA,uCAAuC;AACvC;;EAEE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;EAChC,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,2CAA2C;AAC3C;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,wCAAwC;EACxC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;;EAEE,kEAAkE;EAClE,sCAAsC;AACxC;;AAEA;;EAEE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;;;;EAIE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;;EAEE,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;;;;EAIE,oBAAoB;EACpB,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;;;;;;EAQE,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,0CAA0C;EAC1C,qCAAqC;EACrC,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;EAChC,8EAA8E;EAC9E,4EAA4E;AAC9E;;AAEA;;EAEE,yBAAyB;EACzB,uEAAuE;EACvE,sEAAsE;AACxE;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,gCAAgC;EAChC,8EAA8E;EAC9E,6EAA6E;AAC/E;;AAEA,oBAAoB;AACpB;;EAEE,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,kCAAkC;EAClC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;;EAEE,yEAAyE;AAC3E;;AAEA;;;;;;;;EAQE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,8EAA8E;EAC9E,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;;EAEE,qCAAqC;EACrC,0CAA0C;EAC1C,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;gDAEgD;;AAEhD;;EAEE,wCAAwC;EACxC,qCAAqC;EACrC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;EAC3B,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;;;;EAKE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;;EAEE,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;;;EAIE,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,8EAA8E;EAC9E,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,yEAAyE;EACzE,gDAAgD;EAChD,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;EACrC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;;EAGE,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;EACrC,6BAA6B;EAC7B,2BAA2B;AAC7B","sourcesContent":["/**\n * RT2 revamp — Jira requirements list + AI scenario/test-case views.\n * One surface language: flat cards, clean table, no boxed typography.\n */\n\n/* ═══════════════════════════════════════════\n   Jira host / toolbar\n   ═══════════════════════════════════════════ */\n\n.rt-jira-host.jira-items-overlay,\n.rt-define-panel .rt-jira-host {\n  background: transparent !important;\n}\n\n.rt-jira-host .jira-items-container {\n  background: transparent !important;\n  gap: 0;\n}\n\n.rt-jira-host .jira-items-tabs,\n.rt-define-jira-toolbar {\n  display: flex !important;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 14px !important;\n  padding: 0 0 12px !important;\n  background: transparent !important;\n  border: none !important;\n  border-bottom: 1px solid var(--border) !important;\n  box-shadow: none !important;\n}\n\n.rt-define-jira-tabs .tab-btn {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  color: var(--text-secondary) !important;\n}\n\n.rt-define-jira-tabs .tab-btn.active {\n  color: var(--primary) !important;\n  background: color-mix(in srgb, var(--primary) 10%, transparent) !important;\n  box-shadow: none !important;\n}\n\n.rt-define-jira-actions .generate-all-scenarios-btn,\n.rt-define-jira-actions .generate-all-tests-btn {\n  height: 34px;\n  padding: 0 12px !important;\n  border-radius: 8px !important;\n  font-size: 0.8125rem !important;\n  font-weight: 600 !important;\n  box-shadow: none !important;\n}\n\n.rt-define-jira-actions .generate-all-scenarios-btn {\n  background: color-mix(in srgb, #f59e0b 14%, var(--surface)) !important;\n  border: 1px solid color-mix(in srgb, #f59e0b 35%, var(--border)) !important;\n  color: #b45309 !important;\n}\n\n[data-theme='dark'] .rt-define-jira-actions .generate-all-scenarios-btn {\n  color: #fbbf24 !important;\n}\n\n.rt-define-jira-actions .generate-all-tests-btn {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  color: var(--primary) !important;\n}\n\n.rt-jira-host .sync-stories-btn,\n.rt-jira-host .sync-epic-btn,\n.rt-define-panel .sync-stories-btn,\n.rt-define-panel .sync-epic-btn {\n  height: 34px;\n  padding: 0 12px !important;\n  border-radius: 8px !important;\n  background: var(--primary) !important;\n  border: 1px solid transparent !important;\n  color: #fff !important;\n  font-weight: 600 !important;\n  box-shadow: none !important;\n}\n\n.rt-jira-host .pagination-info,\n.rt-define-panel .pagination-info {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding: 0 !important;\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  color: var(--text-secondary) !important;\n  font-size: 0.8125rem;\n}\n\n/* Keep Sync Epics right-aligned with the per-epic action buttons:\n   card border (1) + header padding (16) + meta gap (16) + icon margin (8) + icon width (16). */\n.rt-jira-host .epic-header .expand-icon {\n  display: inline-flex;\n  justify-content: center;\n  width: 16px;\n}\n\n@media (min-width: 769px) {\n  .rt-jira-host .epics-list > .pagination-info .sync-epic-btn {\n    margin-right: 57px;\n  }\n}\n\n/* ═══════════════════════════════════════════\n   Stories table — single surface, flat cells\n   ═══════════════════════════════════════════ */\n\n.rt-jira-host .stories-table,\n.rt-define-panel .stories-table,\n.rt-legacy-embed .stories-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 12px !important;\n  overflow: hidden;\n  box-shadow: none !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-jira-host .stories-table thead,\n.rt-define-panel .stories-table thead {\n  background: transparent !important;\n}\n\n.rt-jira-host .stories-table th,\n.rt-define-panel .stories-table th {\n  padding: 10px 14px !important;\n  text-align: left !important;\n  font-size: 11px !important;\n  font-weight: 650 !important;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted) !important;\n  background: color-mix(in srgb, var(--text-primary) 3%, transparent) !important;\n  border-bottom: 1px solid var(--border) !important;\n  border-top: none !important;\n  border-left: none !important;\n  border-right: none !important;\n  box-shadow: none !important;\n}\n\n.rt-jira-host .stories-table td,\n.rt-define-panel .stories-table td {\n  padding: 12px 14px !important;\n  vertical-align: middle !important;\n  text-align: left !important;\n  background: transparent !important;\n  border-bottom: 1px solid var(--border-subtle, var(--border)) !important;\n  border-left: none !important;\n  border-right: none !important;\n  border-top: none !important;\n  box-shadow: none !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-jira-host .stories-table tbody tr:last-child td,\n.rt-define-panel .stories-table tbody tr:last-child td {\n  border-bottom: none !important;\n}\n\n.rt-jira-host .stories-table tbody tr:hover td,\n.rt-define-panel .stories-table tbody tr:hover td {\n  background: color-mix(in srgb, var(--primary) 5%, transparent) !important;\n}\n\n/* Kill accidental boxes on cell text */\n.rt-jira-host .stories-table td *,\n.rt-define-panel .stories-table td *:not(.status-badge):not(.priority-badge):not(button):not(svg):not(path):not(circle) {\n  background: transparent !important;\n  box-shadow: none !important;\n  text-shadow: none !important;\n}\n\n.rt-jira-host .story-summary-cell,\n.rt-define-panel .story-summary-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  max-width: 340px;\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n}\n\n.rt-jira-host .story-summary-cell > div:first-child,\n.rt-define-panel .story-summary-cell > div:first-child {\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: var(--text-primary) !important;\n  background: transparent !important;\n  border: none !important;\n  line-height: 1.35;\n}\n\n.rt-jira-host .story-description,\n.rt-define-panel .story-description {\n  font-size: 12px !important;\n  color: var(--text-muted) !important;\n  background: transparent !important;\n  border: none !important;\n  max-width: 340px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-jira-host .stories-table td:first-child,\n.rt-define-panel .stories-table td:first-child {\n  font-weight: 650;\n  color: var(--primary) !important;\n  font-size: 0.8125rem;\n  white-space: nowrap;\n}\n\n.rt-jira-host .epic-link,\n.rt-define-panel .epic-link {\n  color: var(--primary) !important;\n  background: transparent !important;\n  border: none !important;\n  font-weight: 550;\n  font-size: 0.8125rem;\n}\n\n/* Badges — intentional tinted chips only */\n.rt-jira-host .status-badge,\n.rt-define-panel .status-badge,\n.rt-jira-host .priority-badge,\n.rt-define-panel .priority-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px !important;\n  border-radius: 999px !important;\n  font-size: 11px !important;\n  font-weight: 600 !important;\n  border: 1px solid transparent !important;\n  box-shadow: none !important;\n  white-space: nowrap;\n}\n\n.rt-jira-host .status-todo,\n.rt-define-panel .status-todo {\n  background: var(--bg-tertiary) !important;\n  color: var(--text-secondary) !important;\n}\n\n.rt-jira-host .status-in-progress,\n.rt-define-panel .status-in-progress {\n  background: var(--info-muted, rgba(59, 130, 246, 0.12)) !important;\n  color: var(--info, #3b82f6) !important;\n}\n\n.rt-jira-host .status-done,\n.rt-define-panel .status-done {\n  background: var(--success-muted) !important;\n  color: var(--success) !important;\n}\n\n.rt-jira-host .priority-high,\n.rt-define-panel .priority-high,\n.rt-jira-host .priority-badge.priority-high,\n.rt-define-panel .priority-badge.priority-high {\n  background: var(--danger-muted) !important;\n  color: var(--danger) !important;\n}\n\n.rt-jira-host .priority-medium,\n.rt-define-panel .priority-medium {\n  background: var(--warning-muted) !important;\n  color: #b45309 !important;\n}\n\n[data-theme='dark'] .rt-jira-host .priority-medium,\n[data-theme='dark'] .rt-define-panel .priority-medium {\n  color: #fbbf24 !important;\n}\n\n.rt-jira-host .priority-low,\n.rt-define-panel .priority-low {\n  background: var(--success-muted) !important;\n  color: var(--success) !important;\n}\n\n/* Row actions */\n.rt-jira-host .story-action-buttons,\n.rt-define-panel .story-action-buttons,\n.rt-jira-host .epic-action-buttons,\n.rt-define-panel .epic-action-buttons {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.rt-jira-host .generate-tests-btn,\n.rt-define-panel .generate-tests-btn,\n.rt-jira-host .generate-scenarios-btn,\n.rt-define-panel .generate-scenarios-btn,\n.rt-jira-host .view-tests-btn,\n.rt-define-panel .view-tests-btn,\n.rt-jira-host .view-scenarios-btn,\n.rt-define-panel .view-scenarios-btn {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 5px;\n  height: 30px;\n  padding: 0 10px !important;\n  border-radius: 7px !important;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  border: 1px solid var(--border) !important;\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  box-shadow: none !important;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.rt-jira-host .generate-tests-btn,\n.rt-define-panel .generate-tests-btn {\n  color: var(--primary) !important;\n  border-color: color-mix(in srgb, var(--primary) 30%, var(--border)) !important;\n  background: color-mix(in srgb, var(--primary) 8%, var(--surface)) !important;\n}\n\n.rt-jira-host .generate-scenarios-btn,\n.rt-define-panel .generate-scenarios-btn {\n  color: #b45309 !important;\n  border-color: color-mix(in srgb, #f59e0b 35%, var(--border)) !important;\n  background: color-mix(in srgb, #f59e0b 10%, var(--surface)) !important;\n}\n\n[data-theme='dark'] .rt-jira-host .generate-scenarios-btn,\n[data-theme='dark'] .rt-define-panel .generate-scenarios-btn {\n  color: #fbbf24 !important;\n}\n\n.rt-jira-host .view-tests-btn,\n.rt-define-panel .view-tests-btn,\n.rt-jira-host .view-scenarios-btn,\n.rt-define-panel .view-scenarios-btn {\n  color: var(--success) !important;\n  border-color: color-mix(in srgb, var(--success) 30%, var(--border)) !important;\n  background: color-mix(in srgb, var(--success) 10%, var(--surface)) !important;\n}\n\n/* Epic list cards */\n.rt-jira-host .epic-item,\n.rt-define-panel .epic-item {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 12px !important;\n  margin-bottom: 10px;\n  overflow: hidden;\n  box-shadow: none !important;\n}\n\n.rt-jira-host .epic-header,\n.rt-define-panel .epic-header {\n  background: transparent !important;\n  padding: 14px 16px !important;\n  border: none !important;\n}\n\n.rt-jira-host .epic-header:hover,\n.rt-define-panel .epic-header:hover {\n  background: color-mix(in srgb, var(--primary) 4%, transparent) !important;\n}\n\n.rt-jira-host .epic-summary,\n.rt-define-panel .epic-summary,\n.rt-jira-host .jira-key,\n.rt-define-panel .jira-key,\n.rt-jira-host .epic-description,\n.rt-define-panel .epic-description,\n.rt-jira-host .epic-assignee,\n.rt-define-panel .epic-assignee {\n  background: transparent !important;\n  box-shadow: none !important;\n  text-shadow: none !important;\n}\n\n.rt-jira-host .epic-details,\n.rt-define-panel .epic-details {\n  background: color-mix(in srgb, var(--text-primary) 2%, transparent) !important;\n  border-top: 1px solid var(--border) !important;\n  padding: 14px 16px !important;\n}\n\n.rt-jira-host .story-item,\n.rt-define-panel .story-item {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 8px !important;\n  padding: 10px 12px !important;\n  box-shadow: none !important;\n}\n\n/* ═══════════════════════════════════════════\n   AI scenario / test-case generator\n   ═══════════════════════════════════════════ */\n\n.rt-scenario-page .ai-testcase-generator-container,\n.rt-scenario-page.rt-scenario-page {\n  background: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n  border: none !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  margin-top: 0 !important;\n  height: auto !important;\n  min-height: 0 !important;\n}\n\n.rt-scenario-page .rt-scenario-chrome {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 12px !important;\n  margin: 0 0 14px !important;\n  padding: 14px 16px !important;\n}\n\n.rt-scenario-page .generator-content {\n  background: transparent !important;\n  padding: 0 !important;\n}\n\n.rt-scenario-page .test-cases-header,\n.rt-scenario-page .rt-scenario-toolbar {\n  display: flex !important;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 12px !important;\n  padding: 12px 14px !important;\n  margin-bottom: 14px !important;\n  box-shadow: none !important;\n}\n\n.rt-scenario-page .test-cases-title h3 {\n  margin: 0 !important;\n  font-size: 0.95rem !important;\n  font-weight: 650 !important;\n  color: var(--text-primary) !important;\n  background: transparent !important;\n}\n\n.rt-scenario-page .test-case-card {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 12px !important;\n  padding: 16px 18px !important;\n  margin-bottom: 12px;\n  box-shadow: none !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-scenario-page .test-case-header,\n.rt-scenario-page .test-case-meta,\n.rt-scenario-page .test-case-description,\n.rt-scenario-page .test-case-content,\n.rt-scenario-page .test-case-section {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.rt-scenario-page .test-case-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n  padding-bottom: 0 !important;\n}\n\n.rt-scenario-page .test-case-title {\n  margin: 0 !important;\n  font-size: 1rem !important;\n  font-weight: 700 !important;\n  color: var(--text-primary) !important;\n  background: transparent !important;\n}\n\n.rt-scenario-page .test-case-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  margin-bottom: 12px !important;\n  font-size: 0.8125rem;\n  color: var(--text-secondary) !important;\n}\n\n.rt-scenario-page .test-case-meta span,\n.rt-scenario-page .test-case-meta strong {\n  background: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n\n.rt-scenario-page .test-case-description {\n  margin: 0 0 14px !important;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--text-secondary) !important;\n}\n\n.rt-scenario-page .test-case-content {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.rt-scenario-page .test-case-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.rt-scenario-page .test-case-section > h4,\n.rt-scenario-page .test-case-section h4 {\n  margin: 0 !important;\n  padding: 0 !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--text-muted) !important;\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  text-shadow: none !important;\n}\n\n.rt-scenario-page .test-case-section p,\n.rt-scenario-page .test-case-section li,\n.rt-scenario-page .preconditions-list,\n.rt-scenario-page .preconditions-list li {\n  margin: 0 !important;\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  text-shadow: none !important;\n  color: var(--text-primary) !important;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.rt-scenario-page .test-case-section ol,\n.rt-scenario-page .test-case-section ul {\n  margin: 0 !important;\n  padding-left: 1.15rem !important;\n  background: transparent !important;\n}\n\n.rt-scenario-page .bdd-step {\n  background: color-mix(in srgb, var(--text-primary) 4%, transparent) !important;\n  border-radius: 8px !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-scenario-page .expected-result {\n  background: color-mix(in srgb, var(--success) 8%, transparent) !important;\n  border-left: 3px solid var(--success) !important;\n  color: var(--text-primary) !important;\n  border-radius: 0 8px 8px 0 !important;\n}\n\n.rt-scenario-page .regenerate-btn {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  color: var(--text-primary) !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n}\n\n.rt-scenario-page .back-btn,\n.rt-jira-host > .back-btn,\n.rt-jira-host .jira-items-container > .back-btn {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  color: var(--text-primary) !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
